import { AbstractSubscriber } from './AbstractSubscriber'
import { AbstractSearchCore } from './AbstractSearchCore'
import { IMultipleResults } from './IMultipleResults'
import { IFacet } from './IFacet'
import { ISearchConfig } from './ISearchConfig'
import MainModule from '../main'

export class UrlToSearchSubscriber extends AbstractSubscriber {
  private _core: AbstractSearchCore | null = null

  constructor(groupId: string) {
    super(groupId)
  }

  public async attached(core: AbstractSearchCore): Promise<void> {
    this._core = core

    const url = new URL(window.location.href)

    const search = url.searchParams.get('query')
    let parsedSearch = null

    if (search) {
      try {
        parsedSearch = JSON.parse(search)
      } catch (e) {
        console.error('Could not parse search query')
      }
    }

    if (parsedSearch) {
      await this._core.executeSearch(parsedSearch)

      return
    }

    let searchConfig = this._core.searchConfig

    try {
      const region = decodeURIComponent((url.searchParams.get('region') || '') as string)
      const dates = decodeURIComponent((url.searchParams.get('dates') || '') as string)
      const discipline: string = decodeURIComponent(
        (url.searchParams.get('discipline') || '') as string
      )
      let disciplines = discipline.split(',').filter(value => !!value)
      let dateNumbers: number[] = dates.split(',').map((value: string) => {
        let val = undefined
        try {
          val = Number(value)

          if (isNaN(val)) {
            val = undefined
          }
        } catch (e) {}

        return val as number
      })

      const allDatesAreNumbers = dateNumbers.every(el => typeof el === 'number')
      const rangeIsComplete = dateNumbers.length === 2

      if (allDatesAreNumbers && rangeIsComplete) {
        searchConfig.dateFilters = dateNumbers
      }

      if (region) {
        const geo = MainModule.getInstance().getGeo()
        let allCounties = geo ? await geo.getAllCounties() : []

        let location = allCounties.find((county: any) => {
          return county.county === region
        })

        let originalFacet: IFacet | undefined = searchConfig.facets?.find(
          (facet: IFacet) => facet.name === 'touristRegion'
        )
        if (originalFacet) {
          originalFacet.options = []
        } else {
          originalFacet = {
            name: 'touristRegion',
            options: [],
          }

          searchConfig.facets?.push(originalFacet)
        }

        if (location) {
          originalFacet.options.push({
            value: location.county,
            selected: true,
            available: true,
            extraData: location,
          })
        }
      }

      if (disciplines && disciplines.length > 0) {
        let originalFacet: IFacet | undefined = searchConfig.facets?.find(
          (facet: IFacet) => facet.name === 'uiAdditionalTypesCode'
        )
        if (originalFacet) {
          originalFacet.options = []
        } else {
          originalFacet = {
            name: 'uiAdditionalTypesCode',
            options: [],
          }

          searchConfig.facets?.push(originalFacet)
        }

        disciplines.map(value => {
          originalFacet?.options?.push({
            value: `UI-D-${value}`,
            selected: true,
            available: true,
          })
        })
      }
    } catch (e) {
      console.error(e)
      console.error('failed to parse discipline || dates || region')
    }

    await this._core.executeSearch(searchConfig)
  }

  getSearchConfig() {
    return this._core?.searchConfig
  }

  async loadMore(page: number, index: string) {
    if (!this._core) return
    const searchConfig = { ...this._core.searchConfig }
    if (searchConfig?.options?.page) searchConfig.options.page[index] = page
    return this._core?.executeSearch(searchConfig, true)
  }

  async onSearchConfigUpdate(config: ISearchConfig): Promise<void> {}

  async onSearchTextUpdate(text: string): Promise<void> {}

  async onFacetUpdate(facets: IFacet[]): Promise<void> {}

  async onResultUpdate(results: IMultipleResults): Promise<void> {}

  public detaching(): void {
    this._core = null
  }
}
